// extracted by mini-css-extract-plugin
export var dropdown = "_gf-0";
export var imagePlaceholder = "_gf-2";
export var imageWrapper = "_gf-3";
export var productImage = "_gf-1";
export var truncateContainer = "_gf-4";
export var truncateText = "_gf-5";